import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import pvsVerfiedBg from "../../../assets/images/users/pula-verified-background.png"
import { toast } from "react-toastify"
import { UPDATE_PVS_REGISTRATION_RESET } from "../../../redux/types/pvs"
import {
  fetchPvsSubcategory,
  updatePvsRegistration,
} from "../../../redux/actions/pvs"
import { getProductList } from "../../../redux/actions/user"
const ConfirmRegistration = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [termsAccepted, setTermsAccepted] = useState(false)
  const [stepFormData, setStepFormData] = useState(null)
  const [keywordsOptions, setKeywordsOptions] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([])
  const [subcategoryOptions, setSubcategoryOptions] = useState([])

  // Helper function to detect URLs and render them as links
  const renderValue = value => {
    if (Array.isArray(value)) {
      return value
        .map(v => (typeof v === "object" ? v.label || v.value : v))
        .join(", ")
    } else if (typeof value === "object" && value !== null) {
      return value.label || value.value || JSON.stringify(value)
    } else if (typeof value === "string") {
      // Check if the string is a URL
      const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/
      if (urlPattern.test(value)) {
        return (
          <a
            href={value.startsWith("www.") ? `http://${value}` : value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "underline" }}
          >
            {value}
          </a>
        )
      }
    }
    return value || "-"
  }
  const [productOptions, setProductOptions] = useState([])

  const keywordList = useSelector(state => state.pvs.keywordList)
  const categoryList = useSelector(state => state.pvs.categoryList)
  const subcategoryList = useSelector(state => state.pvs.subcategoryList)
  const products = useSelector(state => state.user.products)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const updatePvsRegistrationScreen = useSelector(
    state => state.screens.pvs.updatePvsRegistration
  )

  useEffect(() => {
    if (pvsFormData) {
      let formData = {
        step1: {
          ["Facebook Link"]: pvsFormData.fb_url,
          ["Name"]: pvsFormData.seller_name,
          ["Email"]: pvsFormData.seller_email_id,
          ["Contact"]: pvsFormData.seller_contact_no,
          ["Whatsapp"]: pvsFormData.whatsapp_number,
          ["Pune Address"]: pvsFormData.address,
          ["Permanent Address"]: pvsFormData.permanent_address,
          // ["Has Partner"]:
          //   pvsFormData.team_name !== "" || pvsFormData.team_name !== null,
          ["Partner Name"]: pvsFormData.team_name || "",
          ["Partner Email"]: pvsFormData.team_email || "",
          ["Partner Whatsapp"]: pvsFormData.team_mobile || "",
        },
        step2: {
          ["Aadhar Card"]: { url: pvsFormData.aadhar_card_img_path },
          ["Aadhar Card Back"]: { url: pvsFormData.aadhar_card_img_back_path },
          ["Permanent Address"]: {
            url: pvsFormData.permanent_address_img_path,
          },
          ["Pune Address"]: { url: pvsFormData.pune_address_img_path },
        },
        step3: {
          ["Profile Photo"]: { url: pvsFormData.seller_photo_path },
          ["Brand Logo"]: { url: pvsFormData.brand_logo_path },
        },
        step4: {
          ["Brand Name"]: pvsFormData.brand_name,
          ["Branches"]: pvsFormData.branches
            ? pvsFormData.branches.split(", ")
            : "-",
          ["Website"]: pvsFormData.social_website_link || "-",
          ["Instagram"]: pvsFormData.social_insta_link || "-",
          ["Facebook"]: pvsFormData.social_fb_link || "-",
          ["Google"]: pvsFormData.social_gplus_link || "-",
          ["LinkedIn"]: pvsFormData.social_linkedin_link || "-",
        },
        step5: {
          ["First Name"]: pvsFormData.billing_details?.first_name || "",
          ["Last Name"]: pvsFormData.billing_details?.last_name || "",
          ["Company Name"]: pvsFormData.billing_details?.company_name || "",
          ["Address"]: pvsFormData.billing_details?.address || "",
          ["City"]: pvsFormData.billing_details?.city || "",
          ["State"]: pvsFormData.billing_details?.state || "",
          ["Pincode"]: pvsFormData.billing_details?.pincode || "",
          ["Email"]: pvsFormData.billing_details?.email_id || "",
          ["Mobile No"]: pvsFormData.billing_details?.mobile_no || "",
          ["GST Number"]: pvsFormData.billing_details?.gst_number || "",
        },
      }
      console.log(formData)
      setStepFormData(formData)
    } else {
      navigate("/pvs-info", { replace: true })
    }
  }, [])

  useEffect(() => {
    if (updatePvsRegistrationScreen.success) {
      toast.success(updatePvsRegistrationScreen.message)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
      if (pvsFormData.pay_status === "paid") {
        navigate("/pvs-info")
      } else {
        navigate("/checkout")
      }
    }
    if (updatePvsRegistrationScreen.error) {
      toast.error(updatePvsRegistrationScreen.error)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
    }
  }, [updatePvsRegistrationScreen])

  useEffect(() => {
    if (keywordList && keywordList.length > 0) {
      // console.log("in keyword condition..", keywordList)

      let tempKeywordOption = []
      keywordList.map(option => {
        tempKeywordOption.push({
          label: option.keyword,
          value: option.pvs_key_id,
          encId: option.enc_pvs_key_id,
        })
      })
      // console.log("tempKeywordOption:", tempKeywordOption)
      setKeywordsOptions(tempKeywordOption)
    }
  }, [keywordList])

  useEffect(() => {
    if (categoryList && categoryList.length > 0 && pvsFormData) {
      // console.log("in category condition..", categoryList)

      let tempCategoryOption = []
      categoryList.map(option => {
        tempCategoryOption.push({
          label: option.category,
          value: option.pvs_cat_id,
          encId: option.enc_pvs_cat_id,
        })
      })
      // console.log("tempCategoryOption:", tempCategoryOption)
      setCategoryOptions(tempCategoryOption)
      let tempCat = categoryList.find(
        val => val.value === Number(pvsFormData.categories)
      )
      if (tempCat) {
        dispatch(fetchPvsSubcategory({ enc_pvs_cat_id: tempCat.pvs_cat_id }))
        dispatch(
          getProductList({
            enc_pvs_cat_id: tempCat.enc_pvs_cat_id,
          })
        )
      }
    }
  }, [categoryList])

  useEffect(() => {
    if (subcategoryList && subcategoryList.length > 0) {
      // console.log("in subcategory condition..", subcategoryList)

      let tempSubcategoryOption = []
      subcategoryList.map(option => {
        tempSubcategoryOption.push({
          label: option.subcategory,
          value: option.pvs_subcat_id,
          encId: option.enc_pvs_subcat_id,
        })
      })
      // console.log("tempSubcategoryOption:", tempSubcategoryOption)
      setSubcategoryOptions(tempSubcategoryOption)
    }
  }, [subcategoryList])

  useEffect(() => {
    if (products && products.length > 0) {
      // console.log("in products condition..", products)

      let tempProductOption = []
      products.map(option => {
        tempProductOption.push({
          label: option.product_label,
          value: option.product_id,
          encId: option.enc_product_id,
        })
      })
      // console.log("tempProductOption:", tempProductOption)
      setProductOptions(tempProductOption)
    }
  }, [products])

  useEffect(() => {
    // console.log("keywordsOptions..", keywordsOptions)
    // console.log("categoryOptions", categoryOptions)
    // console.log("subcategoryOptions", subcategoryOptions)

    if (pvsFormData && pvsFormData.keywords && keywordsOptions.length > 0) {
      let keywordArr = pvsFormData.keywords.split(",")

      let selectedKeywords = []

      keywordArr.map(keyword => {
        const foundKeyword = keywordsOptions.find(
          option => option.value === Number(keyword)
        )
        if (foundKeyword) {
          selectedKeywords.push(foundKeyword)
        }
      })
      console.log("selectedKeywords", selectedKeywords)

      setStepFormData(prev => ({
        ...prev,
        step4: {
          ...prev.step4,
          ["Keywords"]: selectedKeywords
            .map(keyword => keyword.label)
            .join(", "),
        },
      }))
    }

    if (pvsFormData && pvsFormData.categories && categoryOptions.length > 0) {
      console.log("pvsFormData.categories", categoryOptions)
      let tempCat = categoryOptions.find(
        val => val.value === Number(pvsFormData.categories)
      )
      console.log("tempCat", tempCat)
      setStepFormData(prev => ({
        ...prev,
        step4: {
          ...prev.step4,
          ["Category"]: tempCat.label,
        },
      }))
    }

    if (
      pvsFormData &&
      pvsFormData.subcategories &&
      subcategoryOptions.length > 0
    ) {
      let subcategoryArr = pvsFormData.subcategories.split(",")
      console.log("subcategoryArr:", subcategoryArr)

      let selectedSubCategories = []
      console.log("subcategoryOptions..", subcategoryOptions)

      subcategoryArr.map(subcategory => {
        // console.log(Number(subcategory))

        const foundSubCategory = subcategoryOptions.find(
          val => val.value === Number(subcategory)
        )
        if (foundSubCategory) {
          selectedSubCategories.push(foundSubCategory)
        }
      })
      console.log("selectedSubCategories", selectedSubCategories)

      setStepFormData(prev => ({
        ...prev,
        step4: {
          ...prev.step4,
          ["Sub Category"]: selectedSubCategories
            .map(subCategory => subCategory.label)
            .join(", "),
        },
      }))
    }

    if (pvsFormData && pvsFormData.products && productOptions.length > 0) {
      let productArr = pvsFormData.products.split(",")

      let selectedProducts = []

      productArr.map(product => {
        console.log(Number(product))

        const foundProduct = productOptions.find(val => {
          // console.log("val", val.value, Number(product))
          return val.value === Number(product)
        })
        if (foundProduct) {
          selectedProducts.push(foundProduct)
        }
      })

      setStepFormData(prev => ({
        ...prev,
        step4: {
          ...prev.step4,
          ["Product"]: selectedProducts
            .map(product => product.label)
            .join(", "),
        },
      }))
    }
  }, [
    pvsFormData,
    keywordsOptions,
    categoryOptions,
    subcategoryOptions,
    productOptions,
  ])

  const onSubmit = () => {
    let requestData = {
      step: 6,
      pvs_entry_id: pvsFormData.pvs_entry_id,
      data: {
        move_to_status: "pending",
        pvs_tnc: {
          accepted: true,
          accepted_at: new Date().toLocaleString(),
          source: "web",
          userAgent: window.navigator.userAgent,
          device: window.navigator.platform,
        },
        total: 1180,
      },
    }
    if (
      pvsFormData.status === "clarification" &&
      pvsFormData.pay_status === "paid"
    ) {
      requestData.data.move_to_status = "paid"
    }
    console.log("request data..", requestData)

    dispatch(updatePvsRegistration(requestData))
  }

  return (
    <>
      <div className="container">
        <div className="mb-5"></div>
        <div className="d-flex flex-column gap-4 py-5">
          {stepFormData ? (
            <Card>
              <CardBody>
                <h3 className="mb-4">Confirm Registration</h3>

                {/* personal details */}
                {stepFormData?.step1 && (
                  <>
                    <h5 className="section-title">Personal Details</h5>
                    <table className="table table-bordered">
                      <tbody>
                        {Object.entries(stepFormData.step1).map(
                          ([key, value]) => (
                            <tr key={key}>
                              <th
                                style={{ width: "30%", background: "#ffe6f5" }}
                              >
                                {key}
                              </th>
                              <td className="word-wrapping">
                                {renderValue(value)}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </>
                )}

                {/* vefification Doc */}
                {stepFormData.step2 && (
                  <>
                    <h5 className="section-title">Verification Details</h5>
                    <table className="table table-bordered">
                      <tbody>
                        {Object.entries(stepFormData.step2).map(
                          ([key, item]) => (
                            <tr key={key}>
                              <th
                                style={{ width: "30%", background: "#ffe6f5" }}
                              >
                                {key}
                              </th>
                              <td>
                                {item ? (
                                  <img
                                    src={item.url}
                                    alt="filename"
                                    style={{
                                      width: "180px",
                                      borderRadius: "6px",
                                    }}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </>
                )}

                {/* id card section */}
                {stepFormData.step3 && (
                  <>
                    <h5 className="section-title">Make Your ID Card</h5>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%", background: "#ffe6f5" }}>
                            Profile Photo
                          </th>
                          <td>
                            <div className="verified-frame">
                              <img
                                src={pvsVerfiedBg}
                                className="bg-frame"
                                alt="verified"
                              />
                              <img
                                src={stepFormData.step3?.["Profile Photo"].url}
                                className="inner-photo"
                                alt="profile"
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <th style={{ width: "30%", background: "#ffe6f5" }}>
                            Company Logo
                          </th>
                          <td>
                            <div className="verified-frame">
                              <img
                                src={pvsVerfiedBg}
                                className="bg-frame"
                                alt="verified"
                              />
                              <img
                                src={stepFormData.step3?.["Brand Logo"].url}
                                className="inner-photo"
                                alt="logo"
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}

                {/* Business DETAILS */}
                <h5 className="section-title">Business Details</h5>
                <table className="table table-bordered">
                  <tbody>
                    {Object.entries(stepFormData.step4).map(([key, value]) => (
                      <tr key={key}>
                        <th style={{ width: "30%", background: "#ffe6f5" }}>
                          {key}
                        </th>
                        <td>{renderValue(value)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* billing details */}
                <h5 className="section-title">Billing Details</h5>
                <table className="table table-bordered">
                  <tbody>
                    {Object.entries(stepFormData.step5).map(([key, value]) => (
                      <tr key={key}>
                        <th style={{ width: "30%", background: "#ffe6f5" }}>
                          {key}
                        </th>
                        <td>{value || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {pvsFormData.status === "pending" ||
                pvsFormData.status === "clarification" ? (
                  <>
                    <div
                      className="my-4 form-check checkbox-verify"
                      style={{
                        border: "1px solid #f2b6d8",
                        background: "#fff1f8",
                        borderRadius: "8px",
                        padding: "12px 14px",
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={termsAccepted}
                        onChange={() => setTermsAccepted(!termsAccepted)}
                        style={{
                          marginTop: 0,
                          marginLeft: 0,
                          marginRight: 5,
                          width: 18,
                          height: 18,
                          accentColor: "#d63384",
                          boxShadow: "0 0 0 2px rgba(214, 51, 132, 0.15)",
                          flex: "0 0 auto",
                        }}
                      />
                      <label
                        className="form-check-label"
                        style={{ cursor: "pointer", fontWeight: 600 }}
                        onClick={() => setTermsAccepted(!termsAccepted)}
                      >
                        Please accept the terms before submitting the form{" "}
                        <span className="text-danger">*</span>{" "}
                        <Link
                          to="https://pulapuneladies.com/terms-and-conditions/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span
                            style={{
                              fontWeight: 600,
                              color: "black",
                              textDecoration: "underline",
                            }}
                          >
                            Click here to read our Terms and Conditions
                          </span>
                        </Link>
                      </label>
                    </div>

                    <div className="confirmbtn-group">
                      <Button
                        className="editinfo"
                        onClick={() =>
                          navigate("/pvs-registration", {
                            state: { allowEdit: true },
                          })
                        }
                      >
                        Edit Info
                      </Button>
                      <Button
                        className="disablecheckout"
                        disabled={!termsAccepted}
                        color="primary"
                        onClick={onSubmit}
                      >
                        {pvsFormData.status === "clarification" &&
                        pvsFormData.pay_status === "paid"
                          ? "Submit"
                          : "Submit and Pay"}
                      </Button>
                    </div>
                  </>
                ) : null}
              </CardBody>
            </Card>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default ConfirmRegistration
